import { render } from "./AdminLeaves.vue?vue&type=template&id=0ba3b738&scoped=true"
import script from "./AdminLeaves.vue?vue&type=script&lang=js"
export * from "./AdminLeaves.vue?vue&type=script&lang=js"

import "./AdminLeaves.vue?vue&type=style&index=0&id=0ba3b738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba3b738"]])

export default __exports__